import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/components/Select';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function BerufeSelect({
  handleChange,
  value,
}: {
  handleChange: (beruf: Beruf) => void;
  value: Beruf;
}) {
  const { t } = useTranslation();
  const {
    store: {
      data: { berufe },
    },
  } = useRotationsplanFeatureContext();

  return (
    <Select<Beruf>
      selectedOption={value}
      onChange={handleChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.fields.beruf.label',
      )}
      options={berufe}
      renderListItem={(beruf) => (
        <div className="flex items-center gap-2">
          <FontAwesomeIcon color={beruf.getBorderColor()} icon={faCircle} />
          <div className="whitespace-nowrap truncate text-sm font-normal">
            {beruf.name}
          </div>
        </div>
      )}
    />
  );
}
